(function () {
  if (window.DS) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DS = (window.DS = {});
  DS.t = function (k, fb) { return (window.DS_T && window.DS_T[k]) || fb; };
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;
  DS.reveal = function (scope) {
    (scope || document).querySelectorAll('.ds-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  };
  DS.money = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  };
  var toast;
  function getToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'ds-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    return toast;
  }
  var toastTimer;
  DS.toast = function (opts) {
    var t = getToast();
    clearTimeout(toastTimer);
    t.classList.toggle('is-error', !!opts.error);
    var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    if (opts.error) {
      t.innerHTML = '<button class="ds-toast__x" aria-label="' + DS.t('close', 'Close') + '">×</button><p class="ds-toast__p">' + esc(opts.error) + '</p>';
    } else {
      t.innerHTML =
        '<button class="ds-toast__x" aria-label="' + DS.t('close', 'Close') + '">×</button>' +
        (opts.image ? '<img class="ds-toast__img" src="' + esc(opts.image) + '" alt="">' : '<span class="ds-toast__img"></span>') +
        '<div><p class="ds-toast__t">' + esc(opts.label || DS.t('added', 'Added to cart')) + '</p><p class="ds-toast__p">' + esc(opts.title) + '</p>' +
        (opts.meta ? '<p class="ds-toast__t" style="margin-top:2px">' + esc(opts.meta) + '</p>' : '') + '</div>' +
        '<div class="ds-toast__actions"><a class="ds-btn ds-btn--ghost" href="' + root + 'cart">' + DS.t('view_cart', 'View cart') + ' (' + (opts.count || 1) + ')</a>' +
        '<a class="ds-btn" href="' + root + 'checkout">' + DS.t('checkout', 'Checkout') + '</a></div>';
    }
    t.querySelector('.ds-toast__x').addEventListener('click', function () { t.classList.remove('is-open'); });
    requestAnimationFrame(function () { t.classList.add('is-open'); });
    toastTimer = setTimeout(function () { t.classList.remove('is-open'); }, opts.error ? 4000 : 6500);
  };
  function updateCartUI(cart) {
    document.querySelectorAll('[data-ds-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    try {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'ds', data: { itemCount: cart.item_count, source: 'ds' } };
      document.dispatchEvent(ev);
    } catch (e) {}
  }
  DS.addToCart = function (variantId, qty, btn, meta) {
    if (!variantId) return Promise.resolve();
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || DS.t('add_error', 'Could not add to cart. Try again.'));
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartUI(cart);
        meta = meta || {};
        DS.toast({ title: meta.title, meta: meta.variant, image: meta.image, count: cart.item_count });
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          var old = btn.getAttribute('data-label') || btn.textContent;
          btn.textContent = DS.t('added_short', 'Added ✓');
          setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = old; btn.disabled = false; }, 1800);
        }
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        DS.toast({ error: err.message });
      });
  };
  DS.buyNow = function (variantId, qty) {
    if (!variantId) return;
    window.location.href = root + 'cart/' + variantId + ':' + (qty || 1);
  };
  var APPAREL = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL'];
  DS.sizeKey = function (s) {
    var up = String(s).toUpperCase().trim();
    var i = APPAREL.indexOf(up);
    if (i > -1) return 1000 + i;
    var n = parseFloat(up.replace(',', '.').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 5000 : n;
  };
  document.addEventListener('DOMContentLoaded', function () { DS.reveal(); });
  if (document.readyState !== 'loading') DS.reveal();
  document.addEventListener('shopify:section:load', function (e) { DS.reveal(e.target); });
})();